import {Backdrop} from '@components/Backdrop'
import {ConnectedComponent} from 'lowkey-component'
import {TextAnimation} from '@components/helpers/TextAnimation'
import {sleep} from '@lib/utils'
import {MediaQuery} from '@services/MediaQuery'
import {appSelectors} from '@store/appSlice'

export class FirstViewScrolledAnimation extends ConnectedComponent {

  mq = MediaQuery.create()
  textList: HTMLDivElement[] = []
  animList: TextAnimation[] = []
  elements: HTMLDivElement[] = []

  didMount() {
    if (this.mq.isPhone()) {
      return
    }

    const backdrop = new Backdrop(this.element as HTMLDivElement)
    backdrop.mount()

    this.elements = [...this.element.querySelectorAll('.js-viewport, .js-viewport-element')] as HTMLDivElement[]

    this.observe(appSelectors.selectOneViewStatus, async (status) => {
      if (status === 'down') {
        this.elements.map(element => {
          element.classList.remove('viewed')
        })
        await sleep(100)
        backdrop.process(this.element)
        this.elements.map(element => {
          element.classList.add('viewed')
        })
      }
      if (status === 'up') {
        this.elements.map(element => {
          element.classList.remove('viewed')
        })
      }
    })
  }

}
